// @flow

import * as React from 'react';
import type { BoundComponent } from '@ta/common.api';

type State = {|
  mounted: boolean,
|};

// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
function getDisplayName(WrappedComponent: React.ComponentType<any>) {
  if (DEBUG) return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return '';
}

const loadOnMount = (Component: BoundComponent<Object>) =>
  class extends React.Component<Object, State> {
    // $FlowFixMe
    static displayName = `${getDisplayName(Component)}loadOnMount`;

    constructor(props: any) {
      super(props);
      this.state = { mounted: false };
    }

    componentDidMount() {
      this.setState({ mounted: true });
      Component.load();
    }

    render() {
      if (!this.state.mounted) return null;
      // $FlowFixMe
      return <Component {...this.props} />;
    }
  };

export default loadOnMount;
